module.exports = __webpack_public_path__ + "img/98.f9517745.jpg";